import React from 'react';
import MyPendingApprovalsPage from '@/pages/approvals/MyPendingApprovalsPage';
import MyApprovalHistoryPage from '@/pages/approvals/MyApprovalHistoryPage';
import PaymentRequestApprovalPage from '@/pages/approvals/PaymentRequestApprovalPage';
import PaymentRequestBulkApprovalPage from '@/pages/approvals/PaymentRequestBulkApprovalPage';
import MyPaymentRequestsPage from '@/pages/my-requests/MyPaymentRequestsPage';
import PublicPaymentRequestPage from '@/pages/finance/PublicPaymentRequestPage';

export const approvalRoutes = [
  { path: '/my-approvals', element: <MyPendingApprovalsPage /> },
  { path: '/my-approvals/history', element: <MyApprovalHistoryPage /> },
  { path: '/my-approvals/:id', element: <PaymentRequestApprovalPage /> },
  { path: 'my-approvals/bulk/:id', element: <PaymentRequestBulkApprovalPage /> },
  { path: '/my-requests', element: <MyPaymentRequestsPage /> },
  { path: '/my-requests/new', element: <PublicPaymentRequestPage /> },
];
